import i18next from 'i18next';

i18next.addResources('es', 'digitalContent', {
  title: 'Contenido destacado',
  subtitle: 'Todos los contenidos',
  titleResponsive: 'Contenidos',
  searchPlaceholder: 'Encuentra publicaciones, videos, noticias y más'
});
